var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLetterX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 80V57.14h11.43V45.71h11.43V34.29H11.43V22.86H0V0h22.86v22.86h11.43v11.43h11.42V22.86h11.43V0H80v22.86H68.57v11.43H57.14v11.42h11.43v11.43H80V80H57.14V57.14H45.71V45.71H34.29v11.43H22.86V80z",
    fill: "#e8ffa2"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCIgdmlld0JveD0iMCAwIDgwIDgwIj4KICA8cGF0aCBkPSJNMCw4MFY1Ny4xNEgxMS40M1Y0NS43MUgyMi44NlYzNC4yOUgxMS40M1YyMi44NkgwVjBIMjIuODZWMjIuODZIMzQuMjlWMzQuMjlINDUuNzFWMjIuODZINTcuMTRWMEg4MFYyMi44Nkg2OC41N1YzNC4yOUg1Ny4xNFY0NS43MUg2OC41N1Y1Ny4xNEg4MFY4MEg1Ny4xNFY1Ny4xNEg0NS43MVY0NS43MUgzNC4yOVY1Ny4xNEgyMi44NlY4MFoiIGZpbGw9IiNlOGZmYTIiLz4KPC9zdmc+Cg==";
export { SvgLetterX as ReactComponent };